/**
 * The live-layout identity strip — DropHero in identityOnly mode, mounted
 * beneath a promoted live stream on CREATOR drops. Extracted from DropPage
 * against the 400-line ceiling; the socials/followMode cast rationale
 * travels with it.
 */
import React from "react";
import {DropHero} from "@/widgets/DropHero";
import type {Drop} from "@/hooks/drop/useGetDrop";

export function buildLiveIdentitySlot({drop, onInviteClick, onLoginRequired, referralUserId}: {
    drop: Drop;
    onInviteClick: () => void;
    onLoginRequired: () => void;
    referralUserId?: string;
}): React.ReactNode {
    return (
        <DropHero
            identityOnly
            dropName={drop.name}
            dropSlug={drop.slug}
            dropId={drop.id}
            themeColors={drop.themeColors}
            /*
             * socials/followMode casts: same runtime values DropPageMain ships
             * through its `drop: any` prop — the typed Drop shape
             * (SurfaceSocialConnection[], no followMode) lags the API response.
             */
            socials={(drop as { socials?: Parameters<typeof DropHero>[0]["socials"] }).socials}
            storefronts={(drop as { storefronts?: Parameters<typeof DropHero>[0]["storefronts"] }).storefronts}
            creatorProfileImageUrl={drop.creatorProfileImageUrl}
            followerCount={drop.followerCount}
            isLive
            joinedAt={drop.createdAt}
            followMode={(drop as { followMode?: Parameters<typeof DropHero>[0]["followMode"] }).followMode}
            onInviteClick={onInviteClick}
            onLoginRequired={onLoginRequired}
            referralUserId={referralUserId}
        />
    );
}
